// extracted by mini-css-extract-plugin
export var displayNone = "_k9-6";
export var imgContainer = "_k9-2";
export var overflowHidden = "_k9-3";
export var productInfoCardButtonContainer = "_k9-5";
export var productTitleText = "_k9-4";
export var rightArrow = "_k9-1";
export var rightArrowContainer = "_k9-0";